import React, { FC } from 'react';
import ErrorComponent from '@ch/common/components/error/error-component';
import { useData } from './use-data';

const TabDuplicatePage: FC = () => {
  const {
    data: {
      keywords: { duplicatedTabTitle, duplicatedTabText },
    },
  } = useData();
  return <ErrorComponent title={duplicatedTabTitle} name="" text={duplicatedTabText} />;
};

export default TabDuplicatePage;
